import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostData,
  type ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostError,
  type ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostResponse,
  resetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPost,
} from '../../generated';

export type ResetImageClassificationMutationVariables =
  ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostData['path'];

export type ResetImageClassificationMutation =
  ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostResponse;

export const useResetImageClassificationMutation = <
  TError = ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<ResetImageClassificationMutation, TError, ResetImageClassificationMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<ResetImageClassificationMutation, TError, ResetImageClassificationMutationVariables, TContext>({
    mutationKey: ['ResetImageClassification'],
    mutationFn: async ({ workspace_id, image_id }: ResetImageClassificationMutationVariables) => {
      const { data } = await resetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPost({
        path: { workspace_id, image_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};
